// Generated by scripts/generate-gameplay-rules.mjs from config/gameplay-rules.json.
export const GAMEPLAY_RULES = {
    "version": "scanner-resource-tuning-v3",
    "core": {
        "gameplayVersion": "CORE_V1",
        "haulPolicyVersion": "common-baseline-haul-v2",
        "unscannedMinimumFinds": 1,
        "unscannedMaximumFinds": 3,
        "targetedCountWeights": [
            85,
            10,
            5
        ],
        "targetedRawPerCore": {
            "COMMON": "10000000",
            "UNCOMMON": "7500000",
            "RARE": "5000000",
            "EPIC": "2000000",
            "LEGENDARY": "1000000"
        },
        "minimumRichnessBps": 8500,
        "maximumRichnessBps": 11500,
        "branchShareBps": 2000
    },
    "weapon": {
        "id": "LASER",
        "cubeSide": 32,
        "ordinaryVoxels": 32,
        "chargedVoxels": 320,
        "ordinaryCooldownMillis": 100,
        "chargeThresholdMillis": 1100,
        "batchAllowances": 10,
        "burstAllowances": 11
    },
    "recovery": {
        "version": "mixed-recovery-v4",
        "minimumMixedUnits": 6,
        "maximumMixedUnits": 14,
        "mixedPriceExponent": 2,
        "unitsPerEvent": 1,
        "scannerDiscoveryEvents": 3,
        "scannerMinimumLevel": 1,
        "scannerMaximumLevel": 60,
        "scannerBonusMilestones": [
            {
                "level": 1,
                "raw": 12
            },
            {
                "level": 10,
                "raw": 24
            },
            {
                "level": 20,
                "raw": 40
            },
            {
                "level": 30,
                "raw": 65
            },
            {
                "level": 45,
                "raw": 95
            },
            {
                "level": 60,
                "raw": 120
            }
        ]
    },
    "emission": {
        "decimals": 6,
        "hoursPerEra": 35064,
        "difficultyScale": 1000000,
        "minimumDifficulty": 10000,
        "maximumDifficulty": 1000000000
    },
    "tiers": [
        {
            "id": "COMMON",
            "weightBps": 10000,
            "lifetimeCap": "1000000000",
            "acquisitionLamports": "250000000",
            "scannerSolMultiplierBps": 10000,
            "resources": [
                "stone",
                "deep_slate",
                "salt",
                "quartz"
            ],
            "dailyProcessedTarget": "1200"
        },
        {
            "id": "UNCOMMON",
            "weightBps": 7500,
            "lifetimeCap": "1000000000",
            "acquisitionLamports": "500000000",
            "scannerSolMultiplierBps": 11000,
            "resources": [
                "iron_ore",
                "copper",
                "bronze",
                "gold"
            ],
            "dailyProcessedTarget": "900"
        },
        {
            "id": "RARE",
            "weightBps": 5000,
            "lifetimeCap": "1000000000",
            "acquisitionLamports": "1000000000",
            "scannerSolMultiplierBps": 12000,
            "resources": [
                "obsidian",
                "redstone",
                "titanium",
                "platinum"
            ],
            "dailyProcessedTarget": "600"
        },
        {
            "id": "EPIC",
            "weightBps": 2000,
            "lifetimeCap": "1000000000",
            "acquisitionLamports": "2000000000",
            "scannerSolMultiplierBps": 13500,
            "resources": [
                "diamond_ore",
                "bedrock",
                "uranium",
                "plutonium"
            ],
            "dailyProcessedTarget": "240"
        },
        {
            "id": "LEGENDARY",
            "weightBps": 1000,
            "lifetimeCap": "1000000000",
            "acquisitionLamports": "4000000000",
            "scannerSolMultiplierBps": 15000,
            "resources": [
                "cobalt",
                "tungsten",
                "iridium",
                "voidglass"
            ],
            "dailyProcessedTarget": "120"
        }
    ],
    "scanner": {
        "acquisitionResources": 50,
        "masterySkipLamportsPerCube": "500000",
        "payoutRollPpm": 1000000,
        "maximumMultiplierBpsByTier": {
            "COMMON": 80000,
            "UNCOMMON": 100000,
            "RARE": 120000,
            "EPIC": 160000,
            "LEGENDARY": 200000
        },
        "payoutBuckets": [
            {
                "id": "STANDARD",
                "ppm": 700000,
                "unlockLevel": 1,
                "ceilingShareBps": 0
            },
            {
                "id": "UNCOMMON",
                "ppm": 200000,
                "unlockLevel": 10,
                "ceilingShareBps": 1000
            },
            {
                "id": "RARE",
                "ppm": 75000,
                "unlockLevel": 25,
                "ceilingShareBps": 2500
            },
            {
                "id": "EPIC",
                "ppm": 20000,
                "unlockLevel": 45,
                "ceilingShareBps": 5000
            },
            {
                "id": "JACKPOT",
                "ppm": 5000,
                "unlockLevel": 60,
                "ceilingShareBps": 10000
            }
        ],
        "mastery": {
            "halfwayLevel": 45,
            "curvePower": 3,
            "cubesAtMaximumByTier": {
                "COMMON": 500,
                "UNCOMMON": 625,
                "RARE": 750,
                "EPIC": 875,
                "LEGENDARY": 1000
            }
        },
        "priceMilestones": [
            {
                "level": 1,
                "commonCumulativeLamports": "20000000",
                "commonCumulativeResources": 50
            },
            {
                "level": 10,
                "commonCumulativeLamports": "60000000",
                "commonCumulativeResources": 200
            },
            {
                "level": 20,
                "commonCumulativeLamports": "120000000",
                "commonCumulativeResources": 750
            },
            {
                "level": 30,
                "commonCumulativeLamports": "250000000",
                "commonCumulativeResources": 2500
            },
            {
                "level": 45,
                "commonCumulativeLamports": "500000000",
                "commonCumulativeResources": 8000
            },
            {
                "level": 60,
                "commonCumulativeLamports": "1000000000",
                "commonCumulativeResources": 24000
            }
        ]
    },
    "cannons": {
        "version": "cannon-charges-v4",
        "ultraLamports": "7700000",
        "vaporizerLamports": "9900000",
        "maximumPurchaseCharges": 1000,
        "defaultUltraCharges": 10,
        "defaultVaporizerCharges": 1
    },
    "autopilot": {
        "productId": "AUTOPILOT_V1",
        "voxelsPerSecond": 320,
        "authorizationSeconds": 604800,
        "maximumNewCubes": 100
    },
    "beams": {
        "version": "charge-paced-beams-v2",
        "meterVoxels": 16384,
        "ultraVoxels": 3277,
        "vaporizerBonusBps": 200,
        "ultraRecoveryMillis": 0,
        "vaporizerRecoveryMillis": 0,
        "ultraChargeMillis": 1600,
        "vaporizerChargeMillis": 3200
    }
};
export const RESOURCE_REGISTRY = [
    {
        "id": "stone",
        "tier": "COMMON",
        "weightBps": 10000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "1200",
        "acquisitionLamports": "250000000"
    },
    {
        "id": "deep_slate",
        "tier": "COMMON",
        "weightBps": 10000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "1200",
        "acquisitionLamports": "250000000"
    },
    {
        "id": "salt",
        "tier": "COMMON",
        "weightBps": 10000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "1200",
        "acquisitionLamports": "250000000"
    },
    {
        "id": "quartz",
        "tier": "COMMON",
        "weightBps": 10000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "1200",
        "acquisitionLamports": "250000000"
    },
    {
        "id": "iron_ore",
        "tier": "UNCOMMON",
        "weightBps": 7500,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "900",
        "acquisitionLamports": "500000000"
    },
    {
        "id": "copper",
        "tier": "UNCOMMON",
        "weightBps": 7500,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "900",
        "acquisitionLamports": "500000000"
    },
    {
        "id": "bronze",
        "tier": "UNCOMMON",
        "weightBps": 7500,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "900",
        "acquisitionLamports": "500000000"
    },
    {
        "id": "gold",
        "tier": "UNCOMMON",
        "weightBps": 7500,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "900",
        "acquisitionLamports": "500000000"
    },
    {
        "id": "obsidian",
        "tier": "RARE",
        "weightBps": 5000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "600",
        "acquisitionLamports": "1000000000"
    },
    {
        "id": "redstone",
        "tier": "RARE",
        "weightBps": 5000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "600",
        "acquisitionLamports": "1000000000"
    },
    {
        "id": "titanium",
        "tier": "RARE",
        "weightBps": 5000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "600",
        "acquisitionLamports": "1000000000"
    },
    {
        "id": "platinum",
        "tier": "RARE",
        "weightBps": 5000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "600",
        "acquisitionLamports": "1000000000"
    },
    {
        "id": "diamond_ore",
        "tier": "EPIC",
        "weightBps": 2000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "240",
        "acquisitionLamports": "2000000000"
    },
    {
        "id": "bedrock",
        "tier": "EPIC",
        "weightBps": 2000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "240",
        "acquisitionLamports": "2000000000"
    },
    {
        "id": "uranium",
        "tier": "EPIC",
        "weightBps": 2000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "240",
        "acquisitionLamports": "2000000000"
    },
    {
        "id": "plutonium",
        "tier": "EPIC",
        "weightBps": 2000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "240",
        "acquisitionLamports": "2000000000"
    },
    {
        "id": "cobalt",
        "tier": "LEGENDARY",
        "weightBps": 1000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "120",
        "acquisitionLamports": "4000000000"
    },
    {
        "id": "tungsten",
        "tier": "LEGENDARY",
        "weightBps": 1000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "120",
        "acquisitionLamports": "4000000000"
    },
    {
        "id": "iridium",
        "tier": "LEGENDARY",
        "weightBps": 1000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "120",
        "acquisitionLamports": "4000000000"
    },
    {
        "id": "voidglass",
        "tier": "LEGENDARY",
        "weightBps": 1000,
        "lifetimeCap": "1000000000",
        "dailyProcessedTarget": "120",
        "acquisitionLamports": "4000000000"
    }
];
export const MIXED_RESOURCE_DROPS = [
    {
        "id": "stone",
        "tier": "COMMON",
        "weight": 256
    },
    {
        "id": "deep_slate",
        "tier": "COMMON",
        "weight": 256
    },
    {
        "id": "salt",
        "tier": "COMMON",
        "weight": 256
    },
    {
        "id": "quartz",
        "tier": "COMMON",
        "weight": 256
    },
    {
        "id": "iron_ore",
        "tier": "UNCOMMON",
        "weight": 64
    },
    {
        "id": "copper",
        "tier": "UNCOMMON",
        "weight": 64
    },
    {
        "id": "bronze",
        "tier": "UNCOMMON",
        "weight": 64
    },
    {
        "id": "gold",
        "tier": "UNCOMMON",
        "weight": 64
    },
    {
        "id": "obsidian",
        "tier": "RARE",
        "weight": 16
    },
    {
        "id": "redstone",
        "tier": "RARE",
        "weight": 16
    },
    {
        "id": "titanium",
        "tier": "RARE",
        "weight": 16
    },
    {
        "id": "platinum",
        "tier": "RARE",
        "weight": 16
    },
    {
        "id": "diamond_ore",
        "tier": "EPIC",
        "weight": 4
    },
    {
        "id": "bedrock",
        "tier": "EPIC",
        "weight": 4
    },
    {
        "id": "uranium",
        "tier": "EPIC",
        "weight": 4
    },
    {
        "id": "plutonium",
        "tier": "EPIC",
        "weight": 4
    },
    {
        "id": "cobalt",
        "tier": "LEGENDARY",
        "weight": 1
    },
    {
        "id": "tungsten",
        "tier": "LEGENDARY",
        "weight": 1
    },
    {
        "id": "iridium",
        "tier": "LEGENDARY",
        "weight": 1
    },
    {
        "id": "voidglass",
        "tier": "LEGENDARY",
        "weight": 1
    }
];
export const SCANNER_TIER_PROGRESSION = [
    {
        "tier": "COMMON",
        "masteryVoxels": [
            "0",
            "71569",
            "143493",
            "216127",
            "289828",
            "364950",
            "441849",
            "520881",
            "602400",
            "686762",
            "774323",
            "865438",
            "960462",
            "1059751",
            "1163660",
            "1272544",
            "1386759",
            "1506661",
            "1632604",
            "1764944",
            "1904037",
            "2050237",
            "2203901",
            "2365383",
            "2535039",
            "2713224",
            "2900295",
            "3096605",
            "3302511",
            "3518368",
            "3744531",
            "3981356",
            "4229198",
            "4488413",
            "4759356",
            "5042381",
            "5337846",
            "5646104",
            "5967512",
            "6302425",
            "6651198",
            "7014187",
            "7391746",
            "7784233",
            "8192000",
            "8615406",
            "9054803",
            "9510549",
            "9982998",
            "10472506",
            "10979428",
            "11504119",
            "12046935",
            "12608232",
            "13188364",
            "13787688",
            "14406558",
            "15045330",
            "15704359",
            "16384000"
        ],
        "resourceWholeUnits": [
            "50",
            "17",
            "17",
            "16",
            "17",
            "17",
            "16",
            "17",
            "17",
            "16",
            "55",
            "55",
            "55",
            "55",
            "55",
            "55",
            "55",
            "55",
            "55",
            "55",
            "175",
            "175",
            "175",
            "175",
            "175",
            "175",
            "175",
            "175",
            "175",
            "175",
            "367",
            "367",
            "366",
            "367",
            "367",
            "366",
            "367",
            "367",
            "366",
            "367",
            "367",
            "366",
            "367",
            "367",
            "366",
            "1067",
            "1067",
            "1066",
            "1067",
            "1067",
            "1066",
            "1067",
            "1067",
            "1066",
            "1067",
            "1067",
            "1066",
            "1067",
            "1067",
            "1066"
        ],
        "solLamports": [
            "250000000",
            "4444445",
            "4444444",
            "4444445",
            "4444444",
            "4444445",
            "4444444",
            "4444445",
            "4444444",
            "4444444",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "13000000",
            "16666667",
            "16666667",
            "16666666",
            "16666667",
            "16666667",
            "16666666",
            "16666667",
            "16666667",
            "16666666",
            "16666667",
            "16666667",
            "16666666",
            "16666667",
            "16666667",
            "16666666",
            "33333334",
            "33333333",
            "33333333",
            "33333334",
            "33333333",
            "33333333",
            "33333334",
            "33333333",
            "33333333",
            "33333334",
            "33333333",
            "33333333",
            "33333334",
            "33333333",
            "33333333"
        ],
        "bonusBaseUnits": [
            "12000000",
            "13333333",
            "14666666",
            "16000000",
            "17333333",
            "18666666",
            "20000000",
            "21333333",
            "22666666",
            "24000000",
            "25600000",
            "27200000",
            "28800000",
            "30400000",
            "32000000",
            "33600000",
            "35200000",
            "36800000",
            "38400000",
            "40000000",
            "42500000",
            "45000000",
            "47500000",
            "50000000",
            "52500000",
            "55000000",
            "57500000",
            "60000000",
            "62500000",
            "65000000",
            "67000000",
            "69000000",
            "71000000",
            "73000000",
            "75000000",
            "77000000",
            "79000000",
            "81000000",
            "83000000",
            "85000000",
            "87000000",
            "89000000",
            "91000000",
            "93000000",
            "95000000",
            "96666666",
            "98333333",
            "100000000",
            "101666666",
            "103333333",
            "105000000",
            "106666666",
            "108333333",
            "110000000",
            "111666666",
            "113333333",
            "115000000",
            "116666666",
            "118333333",
            "120000000"
        ]
    },
    {
        "tier": "UNCOMMON",
        "masteryVoxels": [
            "0",
            "89461",
            "179366",
            "270159",
            "362285",
            "456187",
            "552311",
            "651101",
            "753000",
            "858453",
            "967904",
            "1081797",
            "1200578",
            "1324689",
            "1454575",
            "1590680",
            "1733449",
            "1883326",
            "2040755",
            "2206180",
            "2380046",
            "2562796",
            "2754876",
            "2956728",
            "3168799",
            "3391530",
            "3625368",
            "3870756",
            "4128139",
            "4397960",
            "4680664",
            "4976695",
            "5286498",
            "5610516",
            "5949194",
            "6302977",
            "6672307",
            "7057630",
            "7459390",
            "7878031",
            "8313998",
            "8767733",
            "9239683",
            "9730291",
            "10240000",
            "10769257",
            "11318504",
            "11888186",
            "12478747",
            "13090632",
            "13724284",
            "14380149",
            "15058669",
            "15760290",
            "16485455",
            "17234610",
            "18008197",
            "18806662",
            "19630448",
            "20480000"
        ],
        "resourceWholeUnits": [
            "50",
            "16",
            "16",
            "15",
            "16",
            "16",
            "15",
            "16",
            "16",
            "15",
            "52",
            "52",
            "51",
            "52",
            "51",
            "52",
            "52",
            "51",
            "52",
            "51",
            "164",
            "164",
            "164",
            "164",
            "164",
            "164",
            "164",
            "164",
            "164",
            "164",
            "344",
            "344",
            "344",
            "344",
            "343",
            "344",
            "344",
            "344",
            "344",
            "343",
            "344",
            "344",
            "344",
            "344",
            "343",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000",
            "1000"
        ],
        "solLamports": [
            "500000000",
            "4888889",
            "4888889",
            "4888889",
            "4888889",
            "4888889",
            "4888889",
            "4888889",
            "4888889",
            "4888888",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "6600000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "14300000",
            "18333334",
            "18333333",
            "18333333",
            "18333334",
            "18333333",
            "18333333",
            "18333334",
            "18333333",
            "18333333",
            "18333334",
            "18333333",
            "18333333",
            "18333334",
            "18333333",
            "18333333",
            "36666667",
            "36666667",
            "36666666",
            "36666667",
            "36666667",
            "36666666",
            "36666667",
            "36666667",
            "36666666",
            "36666667",
            "36666667",
            "36666666",
            "36666667",
            "36666667",
            "36666666"
        ],
        "bonusBaseUnits": [
            "9000000",
            "10000000",
            "11000000",
            "12000000",
            "13000000",
            "14000000",
            "15000000",
            "16000000",
            "17000000",
            "18000000",
            "19200000",
            "20400000",
            "21600000",
            "22800000",
            "24000000",
            "25200000",
            "26400000",
            "27600000",
            "28800000",
            "30000000",
            "31875000",
            "33750000",
            "35625000",
            "37500000",
            "39375000",
            "41250000",
            "43125000",
            "45000000",
            "46875000",
            "48750000",
            "50250000",
            "51750000",
            "53250000",
            "54750000",
            "56250000",
            "57750000",
            "59250000",
            "60750000",
            "62250000",
            "63750000",
            "65250000",
            "66750000",
            "68250000",
            "69750000",
            "71250000",
            "72500000",
            "73750000",
            "75000000",
            "76250000",
            "77500000",
            "78750000",
            "80000000",
            "81250000",
            "82500000",
            "83750000",
            "85000000",
            "86250000",
            "87500000",
            "88750000",
            "90000000"
        ]
    },
    {
        "tier": "RARE",
        "masteryVoxels": [
            "0",
            "107353",
            "215239",
            "324190",
            "434741",
            "547425",
            "662773",
            "781321",
            "903600",
            "1030143",
            "1161485",
            "1298157",
            "1440693",
            "1589626",
            "1745490",
            "1908816",
            "2080139",
            "2259991",
            "2448906",
            "2647416",
            "2856055",
            "3075355",
            "3305851",
            "3548074",
            "3802558",
            "4069836",
            "4350442",
            "4644908",
            "4953767",
            "5277552",
            "5616797",
            "5972034",
            "6343797",
            "6732619",
            "7139033",
            "7563572",
            "8006768",
            "8469156",
            "8951268",
            "9453637",
            "9976797",
            "10521280",
            "11087619",
            "11676349",
            "12288000",
            "12923108",
            "13582205",
            "14265823",
            "14974497",
            "15708758",
            "16469141",
            "17256178",
            "18070403",
            "18912348",
            "19782546",
            "20681532",
            "21609836",
            "22567994",
            "23556538",
            "24576000"
        ],
        "resourceWholeUnits": [
            "50",
            "13",
            "13",
            "12",
            "13",
            "12",
            "13",
            "12",
            "13",
            "12",
            "42",
            "41",
            "41",
            "41",
            "41",
            "42",
            "41",
            "41",
            "41",
            "41",
            "132",
            "131",
            "131",
            "132",
            "131",
            "131",
            "132",
            "131",
            "131",
            "131",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "275",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800",
            "800"
        ],
        "solLamports": [
            "1000000000",
            "5333334",
            "5333333",
            "5333333",
            "5333334",
            "5333333",
            "5333333",
            "5333334",
            "5333333",
            "5333333",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "7200000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "15600000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "20000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000",
            "40000000"
        ],
        "bonusBaseUnits": [
            "6000000",
            "6666666",
            "7333333",
            "8000000",
            "8666666",
            "9333333",
            "10000000",
            "10666666",
            "11333333",
            "12000000",
            "12800000",
            "13600000",
            "14400000",
            "15200000",
            "16000000",
            "16800000",
            "17600000",
            "18400000",
            "19200000",
            "20000000",
            "21250000",
            "22500000",
            "23750000",
            "25000000",
            "26250000",
            "27500000",
            "28750000",
            "30000000",
            "31250000",
            "32500000",
            "33500000",
            "34500000",
            "35500000",
            "36500000",
            "37500000",
            "38500000",
            "39500000",
            "40500000",
            "41500000",
            "42500000",
            "43500000",
            "44500000",
            "45500000",
            "46500000",
            "47500000",
            "48333333",
            "49166666",
            "50000000",
            "50833333",
            "51666666",
            "52500000",
            "53333333",
            "54166666",
            "55000000",
            "55833333",
            "56666666",
            "57500000",
            "58333333",
            "59166666",
            "60000000"
        ]
    },
    {
        "tier": "EPIC",
        "masteryVoxels": [
            "0",
            "125245",
            "251112",
            "378222",
            "507198",
            "638662",
            "773236",
            "911541",
            "1054200",
            "1201834",
            "1355065",
            "1514516",
            "1680808",
            "1854564",
            "2036404",
            "2226952",
            "2426829",
            "2636656",
            "2857057",
            "3088652",
            "3332064",
            "3587914",
            "3856826",
            "4139419",
            "4436318",
            "4748142",
            "5075515",
            "5419059",
            "5779394",
            "6157144",
            "6552930",
            "6967373",
            "7401097",
            "7854723",
            "8328872",
            "8824167",
            "9341230",
            "9880682",
            "10443146",
            "11029244",
            "11639596",
            "12274827",
            "12935556",
            "13622407",
            "14336000",
            "15076959",
            "15845905",
            "16643460",
            "17470246",
            "18326885",
            "19213998",
            "20132208",
            "21082136",
            "22064406",
            "23079637",
            "24128453",
            "25211476",
            "26329326",
            "27482627",
            "28672000"
        ],
        "resourceWholeUnits": [
            "50",
            "6",
            "6",
            "6",
            "6",
            "6",
            "6",
            "6",
            "6",
            "5",
            "20",
            "19",
            "19",
            "19",
            "19",
            "20",
            "19",
            "19",
            "19",
            "19",
            "62",
            "61",
            "61",
            "62",
            "61",
            "61",
            "62",
            "61",
            "61",
            "61",
            "129",
            "128",
            "128",
            "129",
            "128",
            "128",
            "129",
            "128",
            "128",
            "129",
            "128",
            "128",
            "129",
            "128",
            "128",
            "374",
            "373",
            "373",
            "374",
            "373",
            "373",
            "374",
            "373",
            "373",
            "374",
            "373",
            "373",
            "374",
            "373",
            "373"
        ],
        "solLamports": [
            "2000000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "6000000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "8100000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "17550000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "22500000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000",
            "45000000"
        ],
        "bonusBaseUnits": [
            "2400000",
            "2666666",
            "2933333",
            "3200000",
            "3466666",
            "3733333",
            "4000000",
            "4266666",
            "4533333",
            "4800000",
            "5120000",
            "5440000",
            "5760000",
            "6080000",
            "6400000",
            "6720000",
            "7040000",
            "7360000",
            "7680000",
            "8000000",
            "8500000",
            "9000000",
            "9500000",
            "10000000",
            "10500000",
            "11000000",
            "11500000",
            "12000000",
            "12500000",
            "13000000",
            "13400000",
            "13800000",
            "14200000",
            "14600000",
            "15000000",
            "15400000",
            "15800000",
            "16200000",
            "16600000",
            "17000000",
            "17400000",
            "17800000",
            "18200000",
            "18600000",
            "19000000",
            "19333333",
            "19666666",
            "20000000",
            "20333333",
            "20666666",
            "21000000",
            "21333333",
            "21666666",
            "22000000",
            "22333333",
            "22666666",
            "23000000",
            "23333333",
            "23666666",
            "24000000"
        ]
    },
    {
        "tier": "LEGENDARY",
        "masteryVoxels": [
            "0",
            "143137",
            "286985",
            "432254",
            "579655",
            "729899",
            "883698",
            "1041761",
            "1204799",
            "1373524",
            "1548646",
            "1730876",
            "1920924",
            "2119501",
            "2327319",
            "2545088",
            "2773518",
            "3013321",
            "3265207",
            "3529888",
            "3808073",
            "4100474",
            "4407801",
            "4730765",
            "5070077",
            "5426448",
            "5800589",
            "6193210",
            "6605022",
            "7036736",
            "7489062",
            "7962712",
            "8458396",
            "8976826",
            "9518711",
            "10084762",
            "10675691",
            "11292208",
            "11935024",
            "12604850",
            "13302396",
            "14028373",
            "14783492",
            "15568465",
            "16384000",
            "17230811",
            "18109606",
            "19021097",
            "19965995",
            "20945011",
            "21958855",
            "23008237",
            "24093870",
            "25216464",
            "26376728",
            "27575375",
            "28813115",
            "30090659",
            "31408717",
            "32768000"
        ],
        "resourceWholeUnits": [
            "50",
            "4",
            "3",
            "3",
            "4",
            "3",
            "3",
            "4",
            "3",
            "3",
            "11",
            "11",
            "11",
            "11",
            "11",
            "11",
            "11",
            "11",
            "11",
            "11",
            "35",
            "35",
            "35",
            "35",
            "35",
            "35",
            "35",
            "35",
            "35",
            "35",
            "74",
            "73",
            "73",
            "74",
            "73",
            "73",
            "74",
            "73",
            "73",
            "74",
            "73",
            "73",
            "74",
            "73",
            "73",
            "214",
            "213",
            "213",
            "214",
            "213",
            "213",
            "214",
            "213",
            "213",
            "214",
            "213",
            "213",
            "214",
            "213",
            "213"
        ],
        "solLamports": [
            "4000000000",
            "6666667",
            "6666667",
            "6666666",
            "6666667",
            "6666667",
            "6666666",
            "6666667",
            "6666667",
            "6666666",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "9000000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "19500000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "25000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000",
            "50000000"
        ],
        "bonusBaseUnits": [
            "1200000",
            "1333333",
            "1466666",
            "1600000",
            "1733333",
            "1866666",
            "2000000",
            "2133333",
            "2266666",
            "2400000",
            "2560000",
            "2720000",
            "2880000",
            "3040000",
            "3200000",
            "3360000",
            "3520000",
            "3680000",
            "3840000",
            "4000000",
            "4250000",
            "4500000",
            "4750000",
            "5000000",
            "5250000",
            "5500000",
            "5750000",
            "6000000",
            "6250000",
            "6500000",
            "6700000",
            "6900000",
            "7100000",
            "7300000",
            "7500000",
            "7700000",
            "7900000",
            "8100000",
            "8300000",
            "8500000",
            "8700000",
            "8900000",
            "9100000",
            "9300000",
            "9500000",
            "9666666",
            "9833333",
            "10000000",
            "10166666",
            "10333333",
            "10500000",
            "10666666",
            "10833333",
            "11000000",
            "11166666",
            "11333333",
            "11500000",
            "11666666",
            "11833333",
            "12000000"
        ]
    }
];
export const CUBE_VOXELS = GAMEPLAY_RULES.weapon.cubeSide ** 3;
export function resourceRules(id) { const row = RESOURCE_REGISTRY.find(row => row.id === id); if (!row)
    throw new Error("Unknown Resource"); return row; }
export function scannerLevelRequirements(id, targetLevel) {
    if (!Number.isSafeInteger(targetLevel) || targetLevel < 1 || targetLevel > GAMEPLAY_RULES.recovery.scannerMaximumLevel)
        throw new RangeError("scanner_level_invalid");
    const resource = resourceRules(id);
    const tier = SCANNER_TIER_PROGRESSION.find(row => row.tier === resource.tier);
    return { masteryVoxels: BigInt(tier.masteryVoxels[targetLevel - 1]), resourceWholeUnits: BigInt(tier.resourceWholeUnits[targetLevel - 1]), solLamports: BigInt(tier.solLamports[targetLevel - 1]) };
}
export function scannerBonusBaseUnits(id, level) {
    const r = GAMEPLAY_RULES.recovery;
    if (!Number.isSafeInteger(level) || level < 0 || level > r.scannerMaximumLevel)
        throw new RangeError("scanner_level_invalid");
    if (level === 0)
        return 0n;
    const tier = SCANNER_TIER_PROGRESSION.find(row => row.tier === resourceRules(id).tier);
    return BigInt(tier.bonusBaseUnits[level - 1]);
}
export function scannerMasterySkipLamports(voxels) {
    if (voxels < 0n || voxels > BigInt(Math.max(...Object.values(GAMEPLAY_RULES.scanner.mastery.cubesAtMaximumByTier))) * BigInt(CUBE_VOXELS))
        throw new RangeError("scanner_skip_invalid");
    return (voxels * BigInt(GAMEPLAY_RULES.scanner.masterySkipLamportsPerCube) + BigInt(CUBE_VOXELS) - 1n) / BigInt(CUBE_VOXELS);
}
/** The bonus curve is an expectation, not the standard payout. */
export function scannerPayoutOutcomes(id, level) {
    if (!Number.isSafeInteger(level) || level < 1 || level > 60)
        throw new RangeError("scanner_level_invalid");
    const maximum = GAMEPLAY_RULES.scanner.maximumMultiplierBpsByTier[resourceRules(id).tier];
    const rows = GAMEPLAY_RULES.scanner.payoutBuckets.map(row => ({ ...row, multiplierBps: level < row.unlockLevel ? 10000 : 10000 + Math.floor((maximum - 10000) * row.ceilingShareBps / 10000) }));
    const weighted = rows.reduce((sum, row) => sum + BigInt(row.ppm) * BigInt(row.multiplierBps), 0n);
    return rows.map(row => ({ ...row, payoutBaseUnits: scannerBonusBaseUnits(id, level) * BigInt(row.multiplierBps) * BigInt(GAMEPLAY_RULES.scanner.payoutRollPpm) / weighted }));
}
export function scannerPayoutBaseUnits(id, level, rollPpm) {
    if (!Number.isSafeInteger(rollPpm) || rollPpm < 0 || rollPpm >= GAMEPLAY_RULES.scanner.payoutRollPpm)
        throw new RangeError("scanner_roll_invalid");
    let cursor = 0;
    for (const row of scannerPayoutOutcomes(id, level)) {
        cursor += row.ppm;
        if (rollPpm < cursor)
            return row.payoutBaseUnits;
    }
    throw new Error("scanner_payout_table_invalid");
}
